export const SET_DARK_MODE = 'SET_DARK_MODE'
